import React from 'react'
import axios from 'axios'
import useForm from '../hooks/useForm'
import { swalError, swalSuccess } from '../common/components/Swaler'

const defaultFormValues = {
  'error-message': false,
  'error-message-explanation': '',
  'red-circle': false,
  'package-together': false,
  'in-person-delivery': false,
  'reason-not-reach-container': false,
  'other-reason': false,
  'other-reason-explanation': '',
}

const formFields = [
  {
    id: 'error-message',
    name: 'error-message',
    label: 'Chauffören fick ett felmeddelande vid öppningsförsök',
  },
  {
    id: 'red-circle',
    name: 'red-circle',
    label: 'Appens "öppna-knapp" lyste rött vid öppningsförsök',
  },
  {
    id: 'pallet-loading',
    name: 'package-together',
    label: 'Sändningen var samlastad på pall',
  },
  {
    id: 'personal-delivery',
    name: 'in-person-delivery',
    label: 'Mottagaren valde att personligen ta emot leveransen',
  },
  {
    id: 'container-access',
    name: 'reason-not-reach-container',
    label: 'Kunde av olika anledningar inte komma till containern',
  },
  {
    id: 'other-reason',
    name: 'other-reason',
    label: 'Annat',
  },
]

const CarrierDeliveryDeviation = ({ location }) => {
  const query = new URLSearchParams(location.search)
  const [formValues, onFormChange] = useForm(defaultFormValues)

  const onSubmit = () => {
    const body = {
      Ämnesrad: query.get('emailSubject'),
      'Kolli-ID (kan finnas fler)': query.get('packageid'),
    }
    const boolMapping = {
      true: 'Ja',
      false: 'Nej',
    }

    formFields.forEach((field) => {
      const { name, label } = field
      let value = formValues[name]

      if (typeof value === 'boolean') {
        value = boolMapping[value]
      }

      body[label] = value

      if (name === 'error-message') {
        body['       Om ja, nämn vilket'] = formValues['error-message-explanation']
      }

      if (name === 'other-reason') {
        body['       Annat (kommentar)'] = formValues['other-reason-explanation']
      }
    })

    axios
      .post('/subject/carrier/forms/delivery-deviation', body)
      .then(() => swalSuccess('Tack', 'Qlocx har blivit informerade', 'OK'))
      .catch((e) => swalError('Ajdå!', e.message))
  }

  return (
    <div style={{ height: '100vh' }}>
      <div style={{ marginLeft: '25%', marginTop: '5%', width: '50%', height: '80%', padding: '10px', background: 'white', boxShadow: '2px 2px 8px 2px lightgrey' }}>
        <h4>Ange orsak för att sändning ej levererades till Qlocx-enhet</h4>
        {formFields.map((field) => (
          <p key={field.id}>
            <input type="checkbox" id={field.id} name={field.name} defaultChecked={false} onChange={onFormChange} />
            <label htmlFor={field.id}>&nbsp; {field.label}</label>
            {field.id === 'error-message' && (
              <div style={{ marginLeft: 10, marginBottom: 10 }}>
                <p>Om ja, nämn vilket:</p>
                <input value={formValues['error-message-explanation']} name="error-message-explanation" type="text" style={{ minWidth: 300 }} onChange={onFormChange} />
              </div>
            )}
            {field.id === 'other-reason' && (
              <div style={{ marginLeft: 10 }}>
                <textarea value={formValues['other-reason-explanation']} type="text" name="other-reason-explanation" style={{ minWidth: 300 }} onChange={onFormChange} />
              </div>
            )}
          </p>
        ))}
        <div style={{ marginTop: 10 }}>
          <button className="smallQbutton" onClick={onSubmit}>
            Skicka
          </button>
        </div>
      </div>
    </div>
  )
}

export default CarrierDeliveryDeviation
